import styled from 'styled-components'
import { IconButton } from '@sevenrooms/ui-kit/form'
import { ModalHeader, HStack, type ModalHeaderProps, type BoxProps } from '@sevenrooms/ui-kit/layout'
import type { PropsWithChildren } from 'react'

interface BackModalHeaderProps extends BoxProps {
  onClose?: NonNullable<ModalHeaderProps['onClose']>
  onBack?: () => void
}

export function BackModalHeader({ onClose, onBack, children, ...props }: PropsWithChildren<BackModalHeaderProps>) {
  return (
    <ModalHeader onClose={onClose} {...props}>
      <StyledHeader justifyContent="space-between" alignItems="center" spacing="m">
        {onBack && <IconButton borderType="none-round" data-test="sr-button-back" size="s" icon="VMSWeb-chevron-left" onClick={onBack} />}
        {children}
      </StyledHeader>
    </ModalHeader>
  )
}

const StyledHeader = styled(HStack)`
  margin-top: -5px;
`
